import styled from 'styled-components';
import { isMobile } from 'utils/is-mobile';
import { TeamLogo as TeamLogoComponent } from 'components/TeamLogo';

export const CardWrapper = styled.div<{
  $bgImageSrc?: string;
}>`
  background: var(--v3-black-0);
  ${props =>
    props.$bgImageSrc &&
    `background: url(${props.$bgImageSrc}) rgba(0, 0, 0, 0.5) no-repeat center center;`}
  background-blend-mode: multiply;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  ${isMobile() ? 'margin: 8px 12px 12px' : 'margin-bottom: 8px'};
  height: ${isMobile() ? '162px' : '128px'};
  border-radius: 6px;
  color: var(--v3-black-0);
  padding: 12px;
`;

export const CardHeader = styled.div`
  color: var(--v3-black-0);
  flex: 0.0000001;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 6px;
`;

export const CardBody = styled.div`
  color: var(--v3-black-0);
  border-top: 1px solid #919191;
  padding-top: 3px;
  flex: 1;
  display: flex;
  justify-content: space-between;
`;

export const CardFooter = styled.div`
  color: white;
  border-top: 1px solid #919191;
  font-size: 12px;
  flex: 0.0000001;
  padding-top: 6px;
  line-height: 100%;
`;

export const TimestampIndicator = styled.div`
  color: white;
  background: var(--v3-red-5);
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 12px;
  line-height: 12px;
  white-space: nowrap;
`;

export const LocationExtra = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;
`;

export const CompetitionName = styled.div`
  color: white;
  font-size: 13px;
  margin-left: 10px;
`;

export const CardBodyTeams = styled.div<{
  $alignment?: string;
}>`
  display: flex;
  flex-direction: column;
  ${props =>
    `justify-content: ${props.$alignment ? props.$alignment : 'flex-end'};`}
  white-space: nowrap;
  overflow: hidden;
`;

export const TeamLogo = styled(TeamLogoComponent)<{
  $sizeByPixels?: number;
}>`
  ${props =>
    `width: ${props.$sizeByPixels ? `${props.$sizeByPixels}px` : '24px'};
    height: ${props.$sizeByPixels ? `${props.$sizeByPixels}px` : '24px'};`}
  font-size: 11px;
  line-height: 11px;
`;

export const TeamName = styled.div`
  font-size: 12px;
  line-height: 12px;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: white;
`;

export const TeamCredentialsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${isMobile() ? '8px' : '10px'};
  margin-bottom: 4px;
  height: ${isMobile() ? '20px' : '24px'};

  & img {
    width: 24px;
    height: 24px;
    font-size: 11px;
    line-height: 11px;
  }
`;

export const Spacer = styled.div`
  flex: 1;
`;
